<template>
  <div v-if="isAdmin" style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input style="width:200px;margin-right:10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.agentName" clearable placeholder="机构名称"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="edit()" type="primary" style="margin-right: 0px;">
          <i class="icon icon_add"></i>
          添加机构
        </el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="agentName" label="考级点名称"></el-table-column>
        <el-table-column prop="userName" label="联系人"></el-table-column>
        <el-table-column prop="phone" label="联系方式"></el-table-column>
        <el-table-column prop="enrollType" label="报名类型">
          <template slot-scope="scope">
            {{$enums.isLine[scope.row.enrollType]}}
          </template>
        </el-table-column>
        <el-table-column prop="receiverAddressInfo2" label="所在地"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
            <!--            <el-button size="mini" type="text" style="color: #E91212;" @click="del(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog :title="(editForm.dataId?'编辑':'创建')+editForm.title" v-if="editForm.show" :visible.sync="editForm.show" width="500px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :agentId="editForm.agentId" @close="getPage()"></Edit>
    </el-dialog>
  </div>
  <div v-else style="padding: 20px;background-color: #ffffff;">
    您暂无权限操作
  </div>
</template>
<script>
import Edit from './agent-edit'

export default {
  name: 'admin',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { agentName: '' },
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, dataId: '', title: '账号' },
      currentUserInfo: this.$store.state.currentUserInfo,
      isAdmin: false
    }
  },
  async created () {
    let roleList = this.currentUserInfo.roleList
    for (let i in roleList) {
      let role = roleList[i]
      if (role.roleName === 'admin') {
        this.isAdmin = true
      }
    }
    if (this.isAdmin) {
      await this.getPage()
    } else {
      throw new Error('您暂无权限操作')
    }
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.dataId = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiAgent.getAgentPage(this.queryParam)
        for (let i = 0; i < page.list.length; i++) {
          let item = page.list[i]
          item.receiverAddressInfo2 = item.parentAddressInfo + '/' + item.addressInfo
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.agentId = row.agentId
      } else {
        this.editForm.agentId = ''
      }
    },
    async del (row) {
      let confirm = await this.$confirm('删除后将无法恢复，确定要删除该记录吗？', '提示', { type: 'warning' })
      if (confirm === 'confirm') {
        await this.$HTTP.ApiUser.del(row.userId)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      }
    },
    async disable (row) {
      await this.$HTTP.ApiUser.disable(row.userId)
      this.$message({ type: 'success', message: '操作成功' })
      await this.getPage()
    },
    async enable (row) {
      await this.$HTTP.ApiUser.enable(row.userId)
      this.$message({ type: 'success', message: '操作成功' })
      await this.getPage()
    }
  }
}
</script>
